import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EzoChatAppComponent } from './ezo-chat-app.component';
import { EzoChatAppService } from '../service/ezo-chat-app.service';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from '../../../../app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import {
  NbActionsModule,
  NbLayoutModule,
  NbMenuModule,
  NbSearchModule,
  NbSidebarModule,
  NbUserModule,
  NbContextMenuModule,
  NbButtonModule,
  NbSelectModule,
  NbIconModule,
  NbSpinnerModule,
  NbThemeModule,
  NbBadgeModule,
  NbCardModule,
  NbListModule,
  NbChatModule,
  NbTooltipModule,
  NbPopoverModule
} from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { MatIconModule } from '@angular/material/icon';
const NB_MODULES = [
  NbCardModule,
   NbListModule,
   NbChatModule,
   NbBadgeModule,
   NbTooltipModule,
   NbLayoutModule,
   NbMenuModule,
   NbUserModule,
   NbActionsModule,
   NbSearchModule,
   NbSidebarModule,
   NbContextMenuModule, 
   NbButtonModule,
   NbSelectModule,
   NbIconModule,
   NbSpinnerModule,
   NbEvaIconsModule,
   NbPopoverModule,
   MatIconModule
 ];
@NgModule({
  declarations: [EzoChatAppComponent],
  imports: [
    CommonModule,   
    FormsModule,
    NB_MODULES  
  ],
  exports:[EzoChatAppComponent],
  providers:[]
})
export class EzoChatAppModule { }